import React, { useState } from 'react';
import './Header.css';
import { useLanguage } from '../context/LanguageContext';

const Header = ({ scrollY }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const { language, toggleLanguage, t } = useLanguage();

  return (
    <header className={`header ${scrollY > 50 ? 'scrolled' : ''} ${menuOpen ? 'menu-open' : ''}`}>
      <div className="header-container">
        <div className="logo">
          <img src="/LOGO.png" alt="Volcano Vodka" className="logo-img" />
        </div>
        
        <nav className={`nav ${menuOpen ? 'nav-open' : ''}`}>
          <a href="#collection" className="nav-link">{t.nav.collection}</a>
          <a href="#philosophy" className="nav-link">{t.nav.source}</a>
          <a href="#community" className="nav-link">{t.nav.experience}</a>
        </nav>

        <div className="header-actions">
          <button 
            className="lang-toggle-btn"
            onClick={toggleLanguage}
            title={language === 'en' ? 'Cambiar a Español' : 'Switch to English'}
          >
            {language === 'en' ? 'ES' : 'EN'}
          </button>
          <button className="age-verify-btn">18+</button>
          <button 
            className={`menu-toggle ${menuOpen ? 'open' : ''}`}
            onClick={() => setMenuOpen(!menuOpen)}
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
